/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Samples_Cargo_OciInputs */

const en_samples_cargo_oci = /** @type {(inputs: Samples_Cargo_OciInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargo OCI#`)
};

const es_samples_cargo_oci = /** @type {(inputs: Samples_Cargo_OciInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargo OCI#`)
};

/**
* | output |
* | --- |
* | "Cargo OCI#" |
*
* @param {Samples_Cargo_OciInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const samples_cargo_oci = /** @type {((inputs?: Samples_Cargo_OciInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Samples_Cargo_OciInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_samples_cargo_oci(inputs)
	return es_samples_cargo_oci(inputs)
});